

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import AddNotificationButton from '@/components/Admin/Layout/AddNotificationButton.vue';
import AddDocumentButton from '@/components/Admin/Layout/AddDocumentButton.vue';
import AddEventButton from '@/components/Admin/Layout/AddEventButton.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import PropertyList from '@/components/Admin/Lists/PropertyList.vue';
import EditPropertyForm from '@/components/Admin/Forms/EditPropertyForm.vue';
import PropertyData from '@/ts/PropertyData';
import AddDocumentForm from '@/components/Admin/Forms/AddDocumentForm.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import AddGroupingForm from '@/components/Admin/Forms/AddGroupingForm.vue';
import EventFlyout from '@/components/Flyouts/EventFlyout.vue';
import BroadcastFlyout from '@/components/Flyouts/BroadcastFlyout.vue';
import Recipients from '@/components/Admin/Panels/Recipients.vue';

@Component({
    components: {
        AddButton,
        AddNotificationButton,
        AddDocumentButton,
        AddEventButton,
        PropertyList,
        EditPropertyForm,
        AddDocumentForm,
        SelectedItems,
        ConfirmPopup,
        AddGroupingForm,
        EventFlyout,
        BroadcastFlyout,
        Recipients,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isAddFormVisible',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class Properties extends Vue {
    @Prop() public propertyData!: PropertyData;

    constructor() {
        super();
    }

    get hasSelectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'].length;
    }

    get hasSelectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'].length;
    }

    get hasSelectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'].length;
    }

    get hasSelectedItem(): boolean {
        return this.hasSelectedProjects ||  this.hasSelectedBuildings || this.hasSelectedProperties;
    }


    get recipientsVisible(): boolean {
        return this.$store.getters['Recipients/getRecipientsVisible'];
    }

    get selectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'];
    }

    get getPropertiesData(): any {
        return this.$store.getters['Properties/allProperties'];
    }

    get activeProperty(): PropertyData {
        return this.$store.getters['Properties/activeProperty'];
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get editMenuVisible() {
        return this.$store.getters['Properties/editMenuVisible'];
    }

    get addUserFormVisible() {
        return this.$store.getters['Properties/addUserMenuVisible'];
    }

    get editPropertyFormVisible() {
        return this.$store.state.Properties.editFormVisible;
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get editMenuClass() {
        return {
            activeForm: this.editMenuVisible,
        };
    }

    get addUserMenuClass() {
        return {
            activeForm: this.addUserFormVisible,
        };
    }

    public diselectAllProperties() {
        const propertyList  = this.$refs.propertyList as any;
        const flexibleTable = propertyList.$refs.flexibleTable as any;
        const qgridTable    = flexibleTable.$refs.qgrid as any;

        flexibleTable.removeSelections();
        qgridTable.selected_prop = [];
    }

    public addGrouping() {
        this.$router.push({name: 'admin-grouping-add'});
    }

    public addProperty() {
        this.$store.dispatch(Actions.INITIATE_PROPERTY);
        this.slideInForm('add-property');
    }

    public addNotification() {
        this.$store.dispatch(Actions.INITIATE_NOTIFICATION);
        this.slideInForm('add-notification');
    }

    public addEvent() {
        this.slideInForm('add-event');
    }

    public addDocument() {
        this.slideInForm('add-document');
    }

    public slideInForm(formKey: string) {
        this.$store.dispatch(Actions.SHOW_FORM, formKey);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_PROPERTIES);
    }

    public beforeCreate() {
        if (typeof this.$route.params.unitId !== 'undefined') {
            this.$store.commit(Mutations.UPDATE_ACTIVE_PROPERTY, parseInt(this.$route.params.unitId, 10));
            this.$store.commit(Mutations.EDIT_ACTIVE_PROPERTY);
            this.$store.commit(Mutations.SHOW_EDIT_PROPERTY_FORM, 'edit-property');
        }
    }
}
